import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Box } from "@chakra-ui/react";
import makeAnimated from "react-select/animated";
import { min } from 'moment/moment';


const ChakraStyledSelect = ({
  placeholder,
  options,
  setSelectedValue,
  selectedValue,
  disabled = false,
isMulti,
}) => {
  // const options = [
  //   { value: "apexGroup", label: "Apex" },
  //   { value: "pranGroup", label: "Pran" },
  //   { value: "horlicksGroup", label: "Horlicks" },
  // ];
  const animatedComponents = makeAnimated();

const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "rgb(19,21,54)",
    borderRadius: "20px",
    color: "white",
    border: "transparent",
    boxShadow: "none",

    minHeight: "46px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#fff",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "white",
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: "rgb(19,21,54)",
    zIndex: 9999,
  }),
  option: (provided, state) => ({
    ...provided,
    borderRadius: "8px",
    color: "white",
    zIndex: 9999,
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    backgroundColor: state.isDisabled
      ? "rgba(255, 255, 255, 0.3)" // Disabled option background color
      : state.isFocused
      ? "rgb(61, 67, 182)" // Focused option background color
      : "rgb(19,21,54)", // Default option background color
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "rgb(29,31,74)",
    borderRadius: "8px",
    color: "white",
    padding: "2px 6px",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "white",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "white",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "red",
      color: "white",
    },
  }),
  indicatorSeparator: (provided) => ({
    display: "none",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "white",
  }),
  input: (provided) => ({
    ...provided,
    color: "white",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    display: "none",
  }),
};
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [values, setValues] = useState([]);
  const handleChange = (selectedOption) => {
    setSelectedOptions(selectedOption);
    setSelectedValue(selectedOption);
  };
  useEffect(() => {
    if (selectedValue) {
      setSelectedOptions(selectedValue);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (options) {
      setValues(options);
    }
  }
  , [options]);



  return (
    <Box w='100%'>
      <Select
        options={values}
        value={selectedOptions}
        isDisabled={disabled}
        components={animatedComponents}
        onChange={(selected) => handleChange(selected)}
        placeholder={placeholder}
        styles={customStyles}
        isMulti={isMulti ?? false}
        
      />
    </Box>
  );
};

export default ChakraStyledSelect;
